import { render, staticRenderFns } from "./squadusermodel.vue?vue&type=template&id=03aa125c"
import script from "./squadusermodel.vue?vue&type=script&lang=js"
export * from "./squadusermodel.vue?vue&type=script&lang=js"
import style0 from "./squadusermodel.vue?vue&type=style&index=0&id=03aa125c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports